"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const BaseColumn_1 = require("./BaseColumn");
const CheckStyle_1 = require("../style/CheckStyle");
const symbolManager_1 = require("../../internal/symbolManager");
const utils_1 = require("../../internal/utils");
const CHECK_COLUMN_STATE_ID = symbolManager_1.getCheckColumnStateId();
function toBoolean(val) {
    if (typeof val === "string") {
        if (val === "false") {
            return false;
        }
        else if (val === "off") {
            return false;
        }
        else if (/^0+$/.exec(val)) {
            return false;
        }
    }
    return Boolean(val);
}
class CheckColumn extends BaseColumn_1.BaseColumn {
    get StyleClass() {
        return CheckStyle_1.CheckStyle;
    }
    clone() {
        return new CheckColumn(this);
    }
    convertInternal(value) {
        return toBoolean(value);
    }
    drawInternal(value, context, style, helper, grid, { drawCellBase }) {
        var _a;
        const { textAlign, textBaseline, borderColor, checkBgColor, uncheckBgColor, bgColor, } = style;
        if (bgColor) {
            drawCellBase({
                bgColor,
            });
        }
        const { col, row } = context;
        const range = grid.getCellRange(col, row);
        const cellKey = `${range.start.col}:${range.start.row}`;
        const elapsed = (_a = grid[CHECK_COLUMN_STATE_ID]) === null || _a === void 0 ? void 0 : _a.elapsed[cellKey];
        const opt = {
            textAlign,
            textBaseline,
            borderColor,
            checkBgColor,
            uncheckBgColor,
        };
        if (utils_1.isDef(elapsed)) {
            opt.animElapsedTime = elapsed;
        }
        helper.checkbox(value, context, opt);
    }
}
exports.CheckColumn = CheckColumn;
